import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PhoneWrapper from './PhoneWrapper';

// Codes are compared case-insensitively and ignoring surrounding spaces, so
// "cpes", "CPES " and "Cpes" all unlock the CPES meeting.
const normalize = (code) => (code || '').trim().toLowerCase();

const storageKey = (slug) => `goihes_passcode_${slug}`;

// True when this browser already entered the meeting's current passcode.
// Storing the code itself (not a flag) means changing the passcode in Mission
// Control re-locks every device that unlocked with the old one.
export function isUnlocked(slug, passcode) {
  try {
    return normalize(localStorage.getItem(storageKey(slug))) === normalize(passcode);
  } catch {
    return false;
  }
}

function remember(slug, code) {
  try {
    localStorage.setItem(storageKey(slug), normalize(code));
  } catch {
    // Private mode / blocked storage: the gate opens for this visit only.
  }
}

export default function PasscodeGate({ meeting, passcode, onUnlock }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const submit = (e) => {
    e.preventDefault();
    if (normalize(code) === normalize(passcode)) {
      remember(meeting.slug, code);
      onUnlock();
    } else {
      setError('That passcode isn’t right. Please try again.');
    }
  };

  return (
    <div data-meeting={meeting.themeSlug || meeting.slug}>
      <PhoneWrapper>
        <div className="portal-statusbar" />
        <form className="portal-gate" onSubmit={submit}>
          <div className="portal-gate-logo">
            <img src={meeting.logo} alt={`${meeting.org} logo`} />
          </div>
          <div>
            <h1 className="portal-gate-title">{meeting.title}</h1>
            <div className="portal-gate-sub">{meeting.dates} · {meeting.city}</div>
          </div>
          <label className="portal-gate-label" htmlFor="portal-gate-input">
            Enter the meeting passcode
          </label>
          <input
            id="portal-gate-input"
            className="portal-gate-input"
            type="text"
            autoComplete="off"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
            autoFocus
            value={code}
            onChange={(e) => { setCode(e.target.value); setError(''); }}
            aria-invalid={Boolean(error)}
            aria-describedby={error ? 'portal-gate-error' : undefined}
          />
          {error && <div id="portal-gate-error" className="portal-gate-error" role="alert">{error}</div>}
          <button type="submit" className="portal-gate-btn" disabled={!code.trim()}>
            Enter
          </button>
          <Link to="/" className="portal-gate-back">← Choose another meeting</Link>
        </form>
    </PhoneWrapper>
    </div>
  );
}
